import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import registerApi from '~/services/register-api/register-api';
import { queryKeys } from '~/store/queryClient';

export default function useRegisterPartnerDetails(partnerId: Ref<number>) {
  return useQuery({
    enabled: () => partnerId.value > 0,
    queryFn: () => registerApi.partner.getDetails(partnerId.value),
    queryKey: computed(() => queryKeys.REGISTER_PARTNER.DETAILS(partnerId.value)),
  });
}
